<template>
  <div class="animated fadeIn">
    <div class="my-5">
      <div class="display-4 font-3xl text-center">
        <span v-if="testPackage && sampleType"
          >Please describe your {{ testPackage.name }}
          {{ sampleType.name }} sample(s).</span
        >
        <span v-else>To fill your sample details, select a package.</span>
      </div>
    </div>
    <div v-if="testPackage" :key="testPackage.id">
      <feeds-submission-form
        v-if="sample_type_name == 'Feed'"
        :submissions="collection"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :testPackage="testPackage"
        :sampleType="sampleType"
        :managedLists="managedLists"
        @onSubmissionsChange="onSubmissionsChange"
      ></feeds-submission-form>
      <feed-mixer-submission-form
        v-else-if="sample_type_name == 'Feed Mixer Efficiency'"
        :submissions="collection"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :testPackage="testPackage"
        :sampleType="sampleType"
        @onSubmissionsChange="onSubmissionsChange"
      ></feed-mixer-submission-form>
      <irrigation-submission-form
        v-else-if="sample_type_name == 'Irrigation Suitability'"
        :submissions="collection"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :testPackage="testPackage"
        :sampleType="sampleType"
        :managedLists="managedLists"
        @onSubmissionsChange="onSubmissionsChange"
      ></irrigation-submission-form>
      <water-submission-form
        v-else-if="sample_type_name == 'Water'"
        :submissions="collection"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :testPackage="testPackage"
        :sampleType="sampleType"
        :managedLists="managedLists"
        @onSubmissionsChange="onSubmissionsChange"
      ></water-submission-form>
      <potato-submission-form
        v-else-if="sample_type_name == 'Potato'"
        :submissions="collection"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :testPackage="testPackage"
        :sampleType="sampleType"
        @onSubmissionsChange="onSubmissionsChange"
      ></potato-submission-form>
      <septic-submission-form
        v-else-if="sample_type_name == 'Septic Soil'"
        :submissions="collection"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :testPackage="testPackage"
        :sampleType="sampleType"
        @onSubmissionsChange="onSubmissionsChange"
      ></septic-submission-form>
      <soil-submission-form
        v-else-if="sample_type_name == 'Soil'"
        :submissions="collection"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        @onSubmissionsChange="onSubmissionsChange"
        :testPackage="testPackage"
        :sampleType="sampleType"
        :turnArounds="turnArounds"
        :allTestPackages="allTestPackages"
      ></soil-submission-form>
      <tissue-submission-form
        v-else-if="sample_type_name == 'Tissue'"
        :submissions="collection"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :testPackage="testPackage"
        :sampleType="sampleType"
        :managedLists="managedLists"
        @onSubmissionsChange="onSubmissionsChange"
      ></tissue-submission-form>
      <general-submission-form
        v-else
        :submissions="collection"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :testPackage="testPackage"
        :sampleType="sampleType"
        :managedLists="managedLists"
        @onSubmissionsChange="onSubmissionsChange"
      ></general-submission-form>
    </div>
  </div>
</template>

<script>
import FeedMixerSubmissionForm from "../../components/submissions/feedMixer/FeedMixerSubmissionForm";
import FeedsSubmissionForm from "../../components/submissions/feeds/FeedsSubmissionForm";
import GeneralSubmissionForm from "../../components/submissions/general/GeneralSubmissionForm";
import IrrigationSubmissionForm from "../../components/submissions/irrigation/IrrigationSubmissionForm";
import PotatoSubmissionForm from "../../components/submissions/potato/PotatoSubmissionForm";
import SepticSubmissionForm from "../../components/submissions/septic/SepticSubmissionForm";
import SoilSubmissionForm from "../../components/submissions/soil/SoilSubmissionForm";
import TissueSubmissionForm from "../../components/submissions/tissue/TissueSubmissionForm";
import TestPackageSampleCollection from "../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../collections/lab/TestPackageCollection";
import WaterSubmissionForm from '../../components/submissions/water/WaterSubmissionForm.vue';
import TurnaroundCollection from '../../collections/lab/TurnaroundCollection';

export default {
  name: "SubmissionAddStep3",
  components: {
    FeedMixerSubmissionForm,
    FeedsSubmissionForm,
    GeneralSubmissionForm,
    IrrigationSubmissionForm,
    PotatoSubmissionForm,
    SepticSubmissionForm,
    SoilSubmissionForm,
    TissueSubmissionForm,
    WaterSubmissionForm
  },
  props: {
    testPackage: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    submissions: {
      type: Array,
      default: () => []
    },
    managedLists: {
      type: Array,
      default: () => []
    },
    sampleType: {
      type: Object,
      default: () => null
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    allTestPackages: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      collection: this.submissions || [],
      sample_type_name: this.sampleType ? this.sampleType.name : null
    };
  },
  methods: {
    onSubmissionsChange(submissions) {
      this.collection = submissions;
      this.$emit("setSubmissions", this.collection);
    }
  }
};
</script>
